import { render, staticRenderFns } from "./InquiryCta.vue?vue&type=template&id=9637ae2e&scoped=true&"
import script from "./InquiryCta.vue?vue&type=script&lang=js&"
export * from "./InquiryCta.vue?vue&type=script&lang=js&"
import style0 from "./InquiryCta.vue?vue&type=style&index=0&id=9637ae2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9637ae2e",
  null
  
)

export default component.exports